<template>
  <div>
    <div><h2>Meus Cursos</h2></div>
    <b-row class="match-height">
      <b-col
        v-for="(curso, index) in cursosXaluno"
        md="6"
        lg="4"
      >
        <b-card
          :img-src="curso.Capa"
          img-alt="Card image cap"
          img-top
          img-height="400px"
        >
          <template #img>
            <img
              :src="curso.Capa"
              alt="Card image cap"
              class="img-fluid"
              style="object-fit: cover; height: 100%;"
            >
          </template>
          <b-card-text>
            <h4> {{ curso.Nome_Curso }}</h4>

            {{ curso.Descricao }}
          </b-card-text>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="handleButtonClick(curso);"
          >
            {{ curso.Progresso === 0 ? 'Iniciar Curso' : 'Continuar Curso' }}
          </b-button>
          <div class="progress-wrapper mt-1">
            <b-card-text class="mb-0">
              {{ curso.Progresso +'%' }}
            </b-card-text>
            <b-progress
              v-model="curso.Progresso"
              max="100"
            />
          </div>
        </b-card>

      </b-col>

    </b-row>
  </div>
</template>

<script>
import {
  BCard, BCardText, BButton, BRow, BCol, BImg, BCardBody, BCardTitle, BCardSubTitle, BLink, BProgress,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useApi } from '@/composables/useApi'

const apiBack = useApi()
export default {
  components: {
    BCard,
    BCardText,
    BProgress,
    BButton,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BRow,
    BCol,
    BLink,
    BImg,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      aluno: [],
      cursosXaluno: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
    }
  },
  computed: {
    getUserData: {
      get() {
        const newUserData = JSON.parse(localStorage.getItem('userData'))
        if (newUserData !== null) {
          this.domainUser = newUserData.user_domain
          return newUserData
        }
        return {}
      },
      set(value) {
        localStorage.setItem('userData', JSON.stringify(value))
      },
    },
  },
  async mounted() {
    await this.buscarAluno()
    await this.buscarCursosXAluno()

    // Set the initial number of items
    this.totalRows = this.cursosXaluno.length
  },
  methods: {
    async handleButtonClick(curso) {
      if (curso.Progresso === 0) {
        this.mudarRota(curso.ID_Curso)
        this.atualizarProgresso(curso)
      } else {
        this.mudarRota(curso.ID_Curso)
        await apiBack.put('/EditProgressoAluno', {
          id_aluno: curso.ID_Aluno,
          id_curso: curso.ID_Curso,
          qtd_acesso: curso.qtd_acesso + 1,
          progresso: curso.Progresso,
        })
          .then(data => {
            console.log(data)
          })
          .catch(err => console.error(err))
      }
    },
    mudarRota(id) {
      return this.$router.push(`/course/${id}`)
    },
    async buscarAluno() {
      await apiBack.get(`/usuario/${this.getUserData.id}`)
        .then(data => {
          this.aluno = data.data[0]
        })
        .catch(err => console.error(err))
    },
    async buscarCursosXAluno() {
      await apiBack.get(`/getAlunosXCursos?id=${this.getUserData.id}`)
        .then(data => {
          this.cursosXaluno = data.data
        })
        .catch(err => console.error(err))
    },
    async atualizarProgresso(curso) {
      console.log(curso)
      await apiBack.put('/EditProgressoAluno', {
        id_aluno: curso.ID_Aluno,
        id_curso: curso.ID_Curso,
        qtd_acesso: 1,
        progresso: 1,
      })
        .then(data => {
          console.log(data)
        })
        .catch(err => console.error(err))
    },

  },
}
</script>
